module.exports = __webpack_public_path__ + "media/img/specialize/item2-3134dd6b04623900b5ee6b50f7da4354.svg";